import { useEffect, useRef } from 'react';

interface LoadMoreSentinelProps {
  onLoadMore: () => void;
  isFetching: boolean;
  hasMore: boolean;
}

export function LoadMoreSentinel({ onLoadMore, isFetching, hasMore }: LoadMoreSentinelProps) {
  const sentinelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting && !isFetching && hasMore) {
          onLoadMore();
        }
      },
      { threshold: 0.1 },
    );

    if (sentinelRef.current) {
      observer.observe(sentinelRef.current);
    }

    return () => observer.disconnect();
  }, [onLoadMore, isFetching, hasMore]);

  return <div ref={sentinelRef} className="h-1" />;
}
